import { useDispatch } from 'react-redux'

import { homeGetStarted } from 'actions/home'

export const useGetHowGoustoWorksData = () => {
  const dispatch = useDispatch()

  return {
    trackClickGetStartedCTA: (ctaUri: string, sectionForTracking: string) =>
      dispatch(homeGetStarted(ctaUri, sectionForTracking)),
  }
}
